import { render, staticRenderFns } from "./bucket.vue?vue&type=template&id=23f4b252&"
import script from "./bucket.vue?vue&type=script&lang=js&"
export * from "./bucket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports